// extracted by mini-css-extract-plugin
export var defaultWrapper = "_me-3";
export var downloadButton = "_me-4";
export var fileContainer = "_me-9 _me-7";
export var fileContainerBase = "_me-7";
export var fileContainerFixedHeight = "_me-8 _me-7";
export var fileInfo = "_me-5";
export var fileInfoWidthRestricted = "_me-6";
export var fileType = "_me-1";
export var fileTypeName = "_me-2";
export var image = "_me-0";
export var link = "_me-b";
export var overflowEllipsis = "_me-a";